import { useTranslation } from 'react-i18next'
import { Button, Checkbox, IconButton, InputAdornment, TextField } from '@mui/material'

import { FormError } from '../../types/common.types'
import { Document } from '../../types/document.types'
import TrashIcon from '../../assets/icons/trash-icon.svg'
import FilterIcon from '../../assets/icons/filter-icon.svg'
import SearchIcon from '../../assets/icons/search-icon.svg'
import { textFieldWhiteBg } from '../../theme/custom-styles'
import { baseButtonWarning } from '../../theme/custom-styles'

const ActionsBar = ({
  errors,
  documentsData,
  documentToSearch,
  showDeleteButton,
  processingDocument,
  searchingInDatabase,
  generalActionChecked,
  handleDialogOpenState,
  handleClearSearchInput,
  handleSetDocumentToSearch,
  handleOpenFiltersOptionsModal,
  handleToggleGeneralActionChecked
}: {
  errors: FormError
  documentToSearch: string
  showDeleteButton: boolean
  searchingInDatabase?: boolean
  processingDocument?: boolean
  generalActionChecked: boolean
  documentsData: Array<Document>
  handleDialogOpenState: () => void
  handleClearSearchInput: () => void
  handleOpenFiltersOptionsModal?: () => void
  handleToggleGeneralActionChecked: (checked: boolean) => void
  handleSetDocumentToSearch: (documentToSearchData: string, showError: boolean) => void
}) => {
  const { t } = useTranslation(['documents-ready-management', 'customer-details-management'])

  return (
    <div className="documents-actions-bar-container">
      <div className="documents-actions-bar-left">
        <div
          className="documents-actions-bar-check-option"
          style={showDeleteButton ? { width: '50%' } : { width: '100%' }}
        >
          {processingDocument === false && (
            <Checkbox
              checked={documentsData.length === 0 ? false : generalActionChecked === true ? true : false}
              disabled={documentsData.length === 0}
              onChange={(event) => handleToggleGeneralActionChecked(event.target.checked)}
            />
          )}
          {documentsData.length === 0 ? (
            <div className="documents-actions-bar-check-option-text">{t('actionsBar.noDocumentsText')}</div>
          ) : (
            <div
              className="documents-actions-bar-check-option-text"
              onClick={() => {
                if (processingDocument === false) {
                  const checkedStateUpdated = generalActionChecked === true ? false : true
                  handleToggleGeneralActionChecked(checkedStateUpdated)
                }
              }}
            >
              {`${documentsData.length === 1 ? t('actionsBar.oneDocumentForDisperse') : t('actionsBar.multipleDocumentsForDisperse')} `}
            </div>
          )}
        </div>
        <div className="documents-actions-bar-button-action-container">
          {documentsData.length > 0 && showDeleteButton && processingDocument === false && (
            <Button
              fullWidth
              variant="text"
              sx={baseButtonWarning}
              startIcon={
                <img
                  src={TrashIcon}
                  alt="trash-icon"
                />
              }
              className="documents-actions-bar-button-action"
              onClick={() => {
                handleDialogOpenState()
              }}
            >
              <div className="documents-actions-bar-button-action-text">{t('actionsBar.buttonsTexts.deleteSelectedDocuments')}</div>
            </Button>
          )}
          <div
            style={{ cursor: 'pointer' }}
            className="filter-button-container"
            onClick={() => handleOpenFiltersOptionsModal?.()}
          >
            {/* !fromDateToSearch && !toDateToSearch && !beneficiaryToSearch ? (
                    <> */}
            <img
              src={FilterIcon}
              alt="filter-icon"
            />
            <div className="filter-button-text">{t('actionsBar.filter', { ns: 'customer-details-management' })}</div>
            {/* </>
                  ) : (
                    <>
                      <div className="filter-button-text">
                        {beneficiaryToSearch && !fromDateToSearch && !toDateToSearch
                          ? beneficiaryToSearch.split('-')[1]
                          : (fromDateToSearch || toDateToSearch) && !beneficiaryToSearch
                          ? `${format(addHours(new Date(fromDateToSearch as Date), 5), 'dd/MM/yyyy')} - ${format(addHours(new Date(toDateToSearch as Date), 5), 'dd/MM/yyyy')}`
                          : ''}
                      </div>
                      <div
                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                        onClick={() => {
                          setToDateToSearch(null)
                          setFromDateToSearch(null)
                          setBeneficiaryToSearch('')
                          setOpenPaymentFiltersModal(false)
                          setCustomerCompanyPaymentToSearch('')
                          handleSetCustomerCompanyPaymentToSearch('', false)
                        }}
                      >
                        <img
                          src={CancelIcon}
                          alt="cancel-icon"
                        />
                      </div>
                    </>
                  ) */}
          </div>
        </div>
      </div>
      <div className="documents-actions-bar-right">
        <TextField
          variant="standard"
          sx={textFieldWhiteBg}
          disabled={searchingInDatabase}
          label={t('searchField.placeholder')}
          value={documentToSearch}
          error={!!errors.documentToSearch}
          helperText={errors.documentToSearch}
          className="documents-actions-bar-search-input"
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault()
              handleSetDocumentToSearch(documentToSearch, true)
            }
          }}
          onChange={(event) => {
            handleSetDocumentToSearch(event.target.value, true)
          }}
          onBlur={() => {
            if (documentToSearch === '') handleClearSearchInput()
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  aria-label="toggle password visibility"
                  sx={{ color: '#107569', right: '10px', bottom: '3px' }}
                >
                  <img
                    src={SearchIcon}
                    alt="search-icon"
                  />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </div>
    </div>
  )
}

export default ActionsBar
